import { render, staticRenderFns } from "./FeedAlertListEmails.vue?vue&type=template&id=573f9c9b&scoped=true&"
import script from "./FeedAlertListEmails.vue?vue&type=script&lang=js&"
export * from "./FeedAlertListEmails.vue?vue&type=script&lang=js&"
import style0 from "./FeedAlertListEmails.vue?vue&type=style&index=0&id=573f9c9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573f9c9b",
  null
  
)

export default component.exports